function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("g", {
  id: "icon-arrow-right-fillable_svg__a",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M7.728 6.956L1.364 13.32l-.707-.707L7.02 6.25z"
}), React.createElement("path", {
  d: "M7.728 6.956l-.707.707L.658 1.3l.706-.71z"
})));

var _ref3 =
/*#__PURE__*/
React.createElement("use", {
  xlinkHref: "#icon-arrow-right-fillable_svg__a"
});

var SvgIconArrowRightFillable = function SvgIconArrowRightFillable(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 8 14",
    focusable: false
  }, props), React.createElement("title", null, title), _ref2, _ref3);
};

export default __webpack_public_path__ + "static/media/icon-arrow-right-fillable.0fded4b8.svg";
export { SvgIconArrowRightFillable as ReactComponent };